import { Directive, HostListener, ElementRef, Renderer2, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[heightHeaderImage]'
})
export class HeightHeaderImageDirective {
    constructor(private elementRef: ElementRef, private renderer: Renderer2) {

    }
    @HostListener('window:scroll', ['$event']) onScrollEvent(event: Event) {
        if (window.pageYOffset > 43) {
            this.renderer.addClass(this.elementRef.nativeElement, "shorten-header-image");
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, "shorten-header-image");
        }
    }
}
